import { transformPropOrder } from '../../html/utils/transform.mjs';
import { number } from '../../../value/types/numbers/index.mjs';
import { px } from '../../../value/types/numbers/units.mjs';
var positionalKeys = new Set(["width", "height", "top", "left", "right", "bottom", "x", "y", "translateX", "translateY"]);
var isNumOrPxType = function isNumOrPxType(v) {
  return v === number || v === px;
};
var getPosFromMatrix = function getPosFromMatrix(matrix, pos) {
  return parseFloat(matrix.split(", ")[pos]);
};
var getTranslateFromMatrix = function getTranslateFromMatrix(pos2, pos3) {
  return function (_bbox, _ref) {
    var transform = _ref.transform;
    if (transform === "none" || !transform) return 0;
    var matrix3d = transform.match(/^matrix3d\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)\)$/);
    if (matrix3d) {
      return getPosFromMatrix(matrix3d[1], pos3);
    } else {
      var matrix = transform.match(/^matrix\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)\)$/);
      if (matrix) {
        return getPosFromMatrix(matrix[1], pos2);
      } else {
        return 0;
      }
    }
  };
};
var transformKeys = new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformPropOrder.filter(function (key) {
  return !transformKeys.has(key);
});
function removeNonTranslationalTransform(visualElement) {
  var removedTransforms = [];
  nonTranslationalTransformKeys.forEach(function (key) {
    var value = visualElement.getValue(key);
    if (value !== undefined) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  });
  return removedTransforms;
}
var positionalValues = {
  // Dimensions
  width: function width(_ref2, _ref3) {
    var x = _ref2.x;
    var _ref3$paddingLeft = _ref3.paddingLeft,
      paddingLeft = _ref3$paddingLeft === void 0 ? "0" : _ref3$paddingLeft,
      _ref3$paddingRight = _ref3.paddingRight,
      paddingRight = _ref3$paddingRight === void 0 ? "0" : _ref3$paddingRight;
    return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
  },
  height: function height(_ref4, _ref5) {
    var y = _ref4.y;
    var _ref5$paddingTop = _ref5.paddingTop,
      paddingTop = _ref5$paddingTop === void 0 ? "0" : _ref5$paddingTop,
      _ref5$paddingBottom = _ref5.paddingBottom,
      paddingBottom = _ref5$paddingBottom === void 0 ? "0" : _ref5$paddingBottom;
    return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
  },
  top: function top(_bbox, _ref6) {
    var _top = _ref6.top;
    return parseFloat(_top);
  },
  left: function left(_bbox, _ref7) {
    var _left = _ref7.left;
    return parseFloat(_left);
  },
  bottom: function bottom(_ref8, _ref9) {
    var y = _ref8.y;
    var top = _ref9.top;
    return parseFloat(top) + (y.max - y.min);
  },
  right: function right(_ref10, _ref11) {
    var x = _ref10.x;
    var left = _ref11.left;
    return parseFloat(left) + (x.max - x.min);
  },
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;
export { isNumOrPxType, positionalKeys, positionalValues, removeNonTranslationalTransform };